import React, { useEffect, useState, useRef, useContext } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { Message } from "primereact/message";
import { Image } from "primereact/image";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { Divider } from "primereact/divider";
import { Fieldset } from "primereact/fieldset";
import { Checkbox } from "primereact/checkbox";
import { applicationsService } from "../../services/ApplicationsService";
import { votersService } from "../../services/VotersService";
import { authenticationService } from "../../services/AuthenticationService";
import { formatDate } from "../../config/Config";
import placeholderImage from "../../assets/images/placeholder.png";
import { AppDB } from "../../App";
import "./ViewApplication.css";
import "./VerifyApplication.scss"; 
import { Dropdown } from "primereact/dropdown";
import {
	APPLICATION_CHECK_DATE_OF_BIRTH,
	APPLICATION_CHECK_DETAILS_ON_CARD_MATCH,
	APPLICATION_CHECK_FACE_LOOKS_FAMILAR,
	APPLICATION_CHECK_FIRST_NAME,
	APPLICATION_CHECK_GENDER,
	APPLICATION_CHECK_ID_CARD_FACE_IMAGE,
	APPLICATION_CHECK_ID_NUMBER,
	APPLICATION_CHECK_LIVE_FACE_IMAGE,
	APPLICATION_CHECK_SURNAME,
	permissionLookUp
} from "../../constants";
import ScreenLoader from "../../componets/ScreenLoader";
import { Badge } from "primereact/badge";
import { changeLang } from "../../componets/Language/ChangeLang";
import { TabView, TabPanel } from 'primereact/tabview';
import { contains } from "jquery";

export default function VerifyApplication({ applicationID, referenceNumber, applicationTypeID, idNumber, visible, onHide, onSubmit }) {
	const [application, setApplication] = useState(null);
	const [applicationRules, setApplicationRules] = useState([]);
	const [binaryData, setBinaryData] = useState([]);
	const [voter, setVoter] = useState(null);
	const [loading, setLoading] = useState(false);
	const [transaction, setTransaction] = useState(null);
	const [showTransaction, setShowTransaction] = useState(false);
	const [reason, setReason] = useState("");
	const [transactionNoteID, setTransactionNoteID] = useState(null);
	const [note, setNote] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const { lookUp, refreshingApplication, seRefreshingApplication } = useContext(AppDB);
	const { permission, toast } = useContext(AppDB);
	const [applicationChecks, setApplicationChecks] = useState([]);
	const [approveEnabled, setApproveEnabled] = useState(false);
	const [canTransact, setCanTransact] = useState(false);
	const [verifiation, setVerification] = useState({ face: false, idInfo: false });
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [contactDetails,setcontactDetails] = useState([]);
	useEffect(() => {
		setLoading(true);
		applicationsService
			.getByID(applicationID)
			.then((data) => {
				setApplication(data?.data);
				setApplicationChecks(data?.data?.applicationChecks);
				console.log(data.applicationChecks);
				//setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching application:", error);
				setLoading(false);
			});

		applicationsService
			.getBinaryDataByID(applicationID)
			.then((data) => {
				setBinaryData(data);
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching application:", error);
				setLoading(false);
			});
	}, [applicationID]);

	useEffect(() => {
		if (applicationTypeID !== 1) {
			setLoading(true);
			votersService
				.getByIDNumber(idNumber)
				.then((data) => {
					setVoter(data);
					setLoading(false);
				})
				.catch((error) => {
					console.error("Error fetching voter:", error);
					setLoading(false);
				});
		}
	}, [idNumber, applicationTypeID]);

	const header = (name) => (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">
				<b>{name}</b>
			</h5>
		</div>
	);

	// useEffect(() => {
	// 	setCanTransact(permission?.actions?.includes(permissionLookUp.Approve) && (permission?.Approve == true || permission?.Reject == true));
	// });

	const onHideTransaction = () => {
		setShowTransaction(false);
		setTransaction(null);
	};

	const onShowTransaction = (transaction) => {
		setTransaction(transaction);
		setShowTransaction(true);
	};

	const onConfirmChange = (ruleID, checked) => {
		var updatedChecks = applicationChecks.map((check) => (check.ruleID === ruleID ? { ...check, confirmed: checked } : check));
		setApplicationChecks(updatedChecks);
		var updatedChecks1 = updatedChecks.filter((check) => check.ruleID === APPLICATION_CHECK_DETAILS_ON_CARD_MATCH);
		var updatedChecks2 = updatedChecks.filter((check) => check.ruleID === APPLICATION_CHECK_FACE_LOOKS_FAMILAR);
		updatedChecks = [...updatedChecks1, ...updatedChecks2];
		// APPLICATION_CHECK_ID_CARD_FACE_IMAGE
		setApproveEnabled(updatedChecks.find((o) => o.confirmed == false) == null);
	};

	function ConfirmCheckbox({ name, similar = false, className }) {
		return (
			<>
				<div className={className}>
					<Checkbox variant="filled" checked={verifiation[name]} onChange={(e) => setVerification({ ...verifiation, [name]: e.checked })} />
					<label className="ml-2">{similar ? "Face look similar" : "Details on card match"}</label>
				</div>
			</>
		);
	}

	function ConfirmCheckboxView(e) {
		const check = applicationChecks.find((o) => o.ruleID == e.ruleID);

		return (
			<>
				<div className={e?.className}>
					<Checkbox
						variant="filled"
						inputId={`${check?.ruleID}`}
						checked={check?.confirmed}
						disabled={permission?.Approve == false && permission?.Reject == false}
						onChange={(e) => onConfirmChange(check?.ruleID, e.checked)}
					/>
					<label htmlFor={`${check?.ruleID}`} className="ml-2">
						{check?.ruleName}
					</label>
				</div>
			</>
		);
	}

	function DetailsView() {
		var faceImage = binaryData.find((o) => o.binaryTypeID === 1);
		var idImage = binaryData.find((o) => o.binaryTypeID === 3);
		var cardFace = binaryData.find((o) => o.binaryTypeID === 2);

		return (
			<div className="grid mt-2 mb-2">
				<div className="col-12 lg:col-4 md:col-6">
					<TabView>
						<TabPanel header="Applicant Details">
							<Fieldset legend="Details" className=" info-fieldset " >
								{application && application.applicationTypeID == 1 && <RegistrationDetails />}
								{application && application.applicationTypeID == 3 && <AmendmentDetails />}
							</Fieldset>
						</TabPanel>
					</TabView>

					{/* <ConfirmCheckboxView className="mt-3" name={"idInfo"} /> */}
					{/* <ConfirmCheckboxView similar={true} ruleID={APPLICATION_CHECK_DETAILS_ON_CARD_MATCH} /> */}

				</div>
				<div className="col-12 lg:col-8 md:col-6 ">



					<TabView activeIndex={activeTabIndex} onTabChange={e => setActiveTabIndex(e.index)}>
						<TabPanel header="National ID">
							<Fieldset legend="ID Card Front Image" className="info-fieldset py-2">
								<div className="my-2">
									<Image
										src={idImage?.binaryData ? idImage?.binaryData : placeholderImage}
										alt={`Image ${faceImage?.binaryType}`}
									
										preview
									
									/>
								</div>
								<ConfirmCheckboxView ruleID={APPLICATION_CHECK_DETAILS_ON_CARD_MATCH} className="my-2" />

							</Fieldset>


						</TabPanel>
						<TabPanel header="Liveness Verification">
							<div className="grid">
								<div className="col-6">
									<Fieldset legend="ID Card Face Image" className="info-fieldset">
										<p className="m-0 center-image">
											<Image
												src={faceImage?.binaryData ? cardFace?.binaryData : placeholderImage}
												alt={`Image ${faceImage?.binaryType}`}
												// width="100px"
												height="100px"
												preview
											/>
										</p>
									</Fieldset>
								</div>
								<div className="col-6">
									<Fieldset legend="Live Face Image" className=" info-fieldset">
										<p className="m-0 center-image">
											<Image
												src={faceImage?.binaryData ? faceImage?.binaryData : placeholderImage}
												alt={`Image ${faceImage?.binaryType}`}
												// width="100px"
												height="100px"
												preview
											/>
										</p>
									</Fieldset>


								</div>
							</div>
							<ConfirmCheckboxView ruleID={APPLICATION_CHECK_FACE_LOOKS_FAMILAR} />

						</TabPanel>

					</TabView>



				</div>
			</div>
		);
	}

	// <div class="field grid legend-block">
	// 				<label class="col-4">Email Address</label>
	// 				<div class="col-4">{application?.registration?.cellphone1?.code}</div>
	// 			</div>
	// 			<div class="field grid legend-block">
	// 				<label class="col-4">Cellphone Number</label>
	// 				<div class="col-4">{application?.registration?.cellphone1?.code}{application?.registration?.cellphone1?.number}</div>
	// 			</div>

	function ContactDetails({ header = "", target = "registration" }) {
		console.log(application)
		const data = [
			{
				col1: "Cellphone Number :",
				col2: <span>{application?.registration?.cellPhone1?.code.concat(application?.registration?.cellPhone1?.number)}</span>,
				col3: "Email Address :",
				col4: <span>{application?.registration?.email}</span>
			}
		];

		return (
			<div className="flex justify-content-start mb-4">
				<DataTable
					className="remove-border"
					header={header}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
						style={{ width: "100%", marginBottom:"10px"}}
				>
			<Column field="col1"  body={(e) => <b>{e.col1}</b>}></Column>
								<Column className="uppercase" field="col2" style={{ width: "250px" }}></Column>
								<Column field="col3"  body={(e) => <b>{e.col3}</b>}></Column>
								<Column className="uppercase" field="col4" style={{ width: "200px" }}></Column>
				</DataTable>
			</div>
		);
	}

		function LivenessInfo({ header = "", target = "registration" }) {
		const data = [
			{
				col1: "Face Matched:",
				col2: application.faceImageMatched ? <Badge severity="success" value={"Yes"} /> : <Badge severity="danger" value={"No"} />,
				col3: "Liveness Verified",
				col4: application.livenessVerified ? <Badge severity="success" value={"Yes"} /> : <Badge severity="danger" value={"No"} />
			}
		];

		return (
			<div className="flex justify-content-start mb-4">
				<DataTable
					className="remove-border"
					header={header}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
						style={{ width: "100%", marginBottom:"10px"}}
				>
			<Column field="col1"  body={(e) => <b>{e.col1}</b>}></Column>
								<Column className="uppercase" field="col2" style={{ width: "250px" }}></Column>
								<Column field="col3"  body={(e) => <b>{e.col3}</b>}></Column>
								<Column className="uppercase" field="col4" style={{ width: "200px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function RegistrationDetails() {
		return (
			<>
				<div class="field grid legend-block">
					<label class="col-4">ID Number</label>
					<div class="col-4">{application?.idNumber}</div>
				</div>
				<div class="field grid legend-block">
					<label class="col-4">Surname</label>
					<div
						className="col-4 truncate-text"
						title={application?.registration?.surname} // 👈 tooltip with full name
						tooltip={application?.registration?.surname}
					>{application?.registration.surname}</div>
				</div>
				<div className="field grid legend-block">
					<label className="col-4">First Name</label>
					<div
						className="col-4 truncate-text"
						title={application?.registration?.name} // 👈 tooltip with full name
						tooltip={application?.registration?.name}
					>
						{application?.registration?.name}
					</div>
				</div>
					<div className="field grid legend-block">
					<label className="col-4">Middle Name</label>
					<div
						className="col-4 truncate-text"
						title={application?.registration?.middlename} // 👈 tooltip with full name
						tooltip={application?.registration?.middlename}
					>
						{application?.registration?.middlename}
					</div>
				</div>
				<div class="field grid legend-block">
					<label class="col-4">Date of Birth</label>
					<div class="col-4">{formatDate(application?.registration?.dateOfBirth?.split(" ")[0])}</div>
				</div>
				<div class="field grid legend-block">
					<label class="col-4">Gender</label>
					<div class="col-4">{application?.registration.gender}</div>
				</div>

				{/* <div class="field grid legend-block">
					<label class="col-4">Disability</label>
					<div class="col-4">{application?.registration.disability}</div>
				</div> */}
			</>
		);
	}

	function AmendmentDetails() {

	const { amendment } = application;

	const hasValue = (val) => val !== undefined && val !== null && val.toString().trim() !== "";

	return (
		<>
			{(application?.idNumber) && (
				<div className="field grid legend-block">
					<label className="col-4">ID Number</label>
					<div className="col-4">{application.idNumber}</div>
				</div>
			)}

				<div className="field grid legend-block">
					<label className="col-4">Surname</label>
					<div className="col-4 truncate-text" title={amendment?.surname}>
						{amendment?.surname}
					</div>
				</div>
			

		
				<div className="field grid legend-block">
					<label className="col-4">First Name</label>
					<div className="col-4 truncate-text" title={amendment?.name}>
						{amendment?.name}
					</div>
				</div>
		

			
				<div className="field grid legend-block">
					<label className="col-4">Middle Name</label>
					<div className="col-8 truncate-text" title={amendment?.middlename}>
						{amendment?.middlename}
					</div>
				</div>
		

				<div className="field grid legend-block">
					<label className="col-4">Date of Birth</label>
					<div className="col-8">
  {amendment?.dateOfBirth 
    ? formatDate(amendment.dateOfBirth.split(" ")[0]) 
    : ""}
</div>

				</div>

				<div className="field grid legend-block">
					<label className="col-4">Gender</label>
					<div className="col-8">{amendment?.gender}</div>
				</div>
				<div className="field grid legend-block">
    <label className="col-4">Cellphone</label>
    <div className="col-8">
        {`${amendment?.cellPhone1?.code || ""}${amendment?.cellPhone1?.number || ""}`}
    </div>
</div>

				<div className="field grid legend-block">
					<label className="col-4">Email Address</label>
					<div className="truncate-text col-8" title={amendment?.email}>
						{amendment?.email}
					</div>
				</div>
			
		</>
	);
}



	function DelimitationView({ header = "", village }) {
		const data = [
			{
				col1: `${changeLang.get("national_delimitation.district")}:`,
				col2: village?.district,
				col3: `${changeLang.get("national_delimitation.constituency")}:`,
				col4: village?.constituency
			},
			{
				col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
				col2: village?.registrationCentre,
				col3: `${changeLang.get("national_delimitation.village")}:`,
				col4: village?.name
			}
		];

		return (
			<div className="flex justify-content-start mb-4">
				<DataTable
					className="remove-border"
					header={header}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
	style={{ width: "100%", marginBottom:"10px"}}				>
				<Column field="col1"  body={(e) => <b>{e.col1}</b>}></Column>
								<Column className="uppercase" field="col2" style={{ width: "250px" }}></Column>
								<Column field="col3"  body={(e) => <b>{e.col3}</b>}></Column>
								<Column className="uppercase" field="col4" style={{ width: "200px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function VoterView() {
		var cellphone1;
		var cellphone2;
		var email = "";

		if (voter) {
			for (const contact of voter?.contactDetails) {
				if (contact.contactType.contactTypeID === 2) {
					email = contact.contactDetail;
				} else {
					if (contact.contactIndex === 1) {
						cellphone1 = `${contact.countryCode.code}${contact.contactDetail}`;
					} else {
						cellphone2 = `${contact.countryCode.code}${contact.contactDetail}`;
					}
				}
			}
		}

		const data = [
			{
				col1: "National ID:",
				col2: voter?.idNumber,
				col3: "Registration Number:",
				col4: voter?.registrationNumber
			},
			{
				col1: "Surname:",
				col2: voter?.surname,
				col3: "Firstname:",
				col4: voter?.firstname
			},
			{
				col1: "Date Of Birth:",
				col2: formatDate(voter?.dateOfBirth?.split(" ")[0]),
				col3: "Gender:",
				col4: voter?.gender
			},
			{
				col1: "Cellphone(1):",
				col2: cellphone1,
				col3: "Cellphone(2):",
				col4: cellphone2
			},
			{
				col1: "Email:",
				col2: email,
				col3: "",
				col4: ""
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border "
					header={header("Original Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%", marginBottom:"10px"}}
				>
				<Column field="col1"  body={(e) => <b>{e.col1}</b>}></Column>
								<Column className="uppercase" field="col2" style={{ width: "250px" }}></Column>
								<Column field="col3"  body={(e) => <b>{e.col3}</b>}></Column>
								<Column className="uppercase" field="col4" style={{ width: "200px" }}></Column>
				</DataTable>
				{/* <br />
                <DelimitationView header={header("Demarcation")} village={voter?.village} /> */}
			</div>
		);
	}

	async function transact(transaction) {
		setLoading(true);
		setErrorMessage("");
		try {
			var response;
			if (transaction === "Approve") {
				response = await applicationsService.verify({
					applicationID,
					reason: "Verify",
					note: note,
					applicationChecks
				});
			} else {
				response = await applicationsService.reject({
					applicationIDs: [applicationID],
					reason: reason,
					note: note,
					transactionNoteID: transactionNoteID,
					applicationChecks,
					applicationTypeID
				});
			}
			setLoading(false);

			if (response.success) {
				//setTransaction(null);
				//setShowTransaction(false);
				onSubmit();
				seRefreshingApplication(!refreshingApplication);
				return toast.show({
					severity: "success",
					summary: "Success Message",
					detail: transaction === "Approve" ? "Application submitted successfully" : "Application rejected successfully",
					life: 1500
				});
			} else {
				setErrorMessage(response.message);
				return toast.show({
					severity: "error",
					summary: "Error",
					detail: response.message,
					life: 2500
				});
			}
		} catch (error) {
			setLoading(false);
			setErrorMessage("Remote server error occured. Please try again or consult your system adminstrator.");
			return toast.show({
				severity: "error",
				summary: "Error",
				detail: "Remote server error occured. Please try again or consult your system adminstrator.",
				life: 2500
			});
		}
	}

	return (
		<>
			<Dialog
				modal={true}
				style={{ width: "90%", height: "90%" }}
				draggable={false}
				header={
					<>
						<span>
							{application?.applicationType} Application - {referenceNumber}
						</span>
					</>
				}
				footer={
					<>
						{permission?.actions?.includes(permissionLookUp.Approve) && permission?.Approve == true && (
							<Button
								className="p-button-primary"
								icon="pi pi-check"
								type="button"
								label="Accept"
								disabled={!approveEnabled}
								onClick={() => transact("Approve")}
							/>
						)}
						{permission?.actions?.includes(permissionLookUp.Reject) && permission?.Reject == true && (
							<Button
								disabled={approveEnabled}
								className="p-button-primary"
								icon="pi pi-times"
								type="button"
								label="Reject"
								onClick={() => {
									// transact("Reject")
									onShowTransaction("Reject");
								}}
							/>
						)}
						<Button
							className="p-button-danger"
							icon="pi pi-times-circle"
							type="button"
							label="Close"
							onClick={() => {
								onHide();
							}}
						/>
					</>
				}
				visible={visible}
				onHide={(e) => {
					setApplication(null);
					onHide();
				}}
				onShow={() => { }}
			>
				<div className="grid">
					<ScreenLoader visible={loading} />
					<div className="col-12 lg:col-12">
						{application && <DetailsView />}
						{application && application.applicationTypeID == 1 && (
							<>
								<ContactDetails header={header("Contact Details")} />
								<LivenessInfo header={header("Liveness Info")} />
								<DelimitationView header={header("Demarcation")} village={application?.village} />
							</>
						)}
						{application && application.applicationTypeID == 3 && (
							<>
								<VoterView />
								<LivenessInfo header={header("Liveness Info")}  />
								<DelimitationView header={header("Demarcation")} village={application?.village} />
							</>
						)}
					</div>
				</div>
			</Dialog>
			<Dialog
				header={`${transaction} Application`}
				visible={showTransaction}
				style={{ width: "40vw" }}
				footer={
					<div>
						<Button
							icon="pi pi-check"
							loading={loading}
							label="Submit"
							onClick={(e) => {
								transact("Reject");
							}}
							className="p-button-primary"
						/>
						<Button icon="pi pi-times-circle" label="Cancel" onClick={onHideTransaction} className="p-button-danger" />
					</div>
				}
				onHide={onHideTransaction}
			>
				{/*<div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">Reason:</label>
					<InputTextarea id="reason" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
				</div> */}
				 <div className="flex flex-column gap-2 mb-4">
					<label htmlFor="reason">Reason:</label>
					<Dropdown
						filter
						style={{ width: "100%" }}
						optionLabel="name"
						optionValue="id"
						value={transactionNoteID}
						onChange={(e) =>{
							setTransactionNoteID(e.value)
						}}
						options={lookUp?.transactionNotes}
						placeholder="Select a rejection reason"
					/>
				</div>
				{/* <div className="flex flex-column gap-2">
					<label htmlFor="notes">Additional Notes:</label>
					<InputTextarea id="notes" rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
				</div> */}
				{errorMessage && <Message severity="error" text={errorMessage} style={{ marginTop: "0.5em" }} />}
			</Dialog>
		</>
	);
}
